import { css } from '@emotion/react';

export const traveler_picker_no_results = css`
  padding: 2rem;
  text-align: center;
  position: relative;
`;
